<template lang="pug">
  form(@submit.prevent="")
    .md-layout
      .text-center.md-layout-item.md-size-100(v-if="success")
        h4 You have opened a position! Manage your positions here.
        md-button.md-success(@click="$router.push('/positions')") POSITIONS
      .md-layout-item.md-size-100(v-else)
        .md-layout-item.md-size-100
          p Your Cash Balance:
          md-field
            p ${{cash_balance}}
        .md-layout-item.md-size-100
          p Your position:
          md-field
            p {{position}}
        .md-layout-item.md-size-100
          p Current stock price:
          md-field
            p {{stock_price}}
        .md-layout-item.md-size-100
          p How much money do you want to invest?
          md-field
            md-input(type="number" min="0" v-model="amount")
        .text-center.md-layout-item
          h6(v-if="error" style="color: red") {{error}}
          md-button(type="submit" v-on:click="placeVote") Open position
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      success: null,
      error: null,
      initialError: null,
      amount: 0,
      cash_balance: null,
      stock_price: null,
    }
  },
  props: {
    pitch_id: {
      type: Number,
      default: null
    },
    position: {
      type: String,
      default: null
    }
  },
  mounted() {
    axios.get(`/api/trading/member_position/check_position?pitch_id=${this.pitch_id}`)
    .then((res) => {
      if(res.data.has_position) {
        this.success = true;
      } else {
        this.stock_price = res.data.stock_price;
        this.cash_balance = res.data.cash;
      }
    }).catch((err) => {
      console.log(err.response);
    });
  },
  methods: {
    placeVote() {
      if (this.amount > 0) {
        axios.post(`/api/trading/member_position/open_position`, {new_capital: this.amount, pitch_id: this.pitch_id})
        .then((res) => {
          this.success = true;
        }).catch((err) => {
          this.error = err.response.data.error;
        });
      } else {
        this.error = "Please input an amount greater than $0";
      }

    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/Trading/NewPositionForm.vue